/* eslint-disable no-lonely-if */
/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import { logoutUser } from '../store/actions';


export const getToken = (dispatch) => {
  const accessToken = localStorage.getItem('token');
  const expiresIn = localStorage.getItem('expires_in');

  return new Promise((resolve) => {
    const diff = moment.unix(Number(expiresIn)).diff(moment(), 'minutes');

    if (accessToken && diff > 5) {
      resolve(accessToken);
    } else {
      // eslint-disable-next-line no-unused-expressions
      dispatch && dispatch(logoutUser());
      resolve(accessToken);
    }
  });
};

export const getPager = (totalItems, currentPage, pagesize) => {
  // default to first page
  currentPage = currentPage || 1;

  // default page size is 10
  pagesize = pagesize || 10;

  // calculate total pages
  const totalPages = Math.ceil(totalItems / pagesize);

  let startPage;
  let endPage;
  if (totalPages <= 10) {
    // less than 10 total pages so show all
    startPage = 1;
    endPage = totalPages;
  }
  else {
    // more than 10 total pages so calculate start and end pages
    if (currentPage <= 6) {
      startPage = 1;
      endPage = 5;
    }
    else if (currentPage + 4 >= totalPages) {
      startPage = totalPages - 9;
      endPage = totalPages;
    }
    else {
      startPage = currentPage - 5;
      endPage = currentPage + 4;
    }
  }

  // calculate start and end item indexes
  const startIndex = (currentPage - 1) * pagesize;
  const endIndex = Math.min(startIndex + pagesize - 1, totalItems - 1);

  // create an array of pages to ng-repeat in the pager control
  const pages = [...Array(endPage + 1 - startPage).keys()].map((i) => startPage + i);

  // return object with all pager properties required by the view

  return {
    totalItems,
    currentPage,
    pagesize,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages,
  };
};
// export const getPager = (totalItems, currentPage = 1, pageSize = 10) => {
//   const totalPages = Math.ceil(totalItems / pageSize);


//   let startPage, endPage;// eslint-disable-line one-var
//   if (totalPages <= 10) {
//     // less than 10 total pages so show all
//     startPage = 1;
//     endPage = totalPages;
//   } else {
//     // more than 10 total pages so calculate start and end pages
//     if (currentPage <= 6) {
//       startPage = 1;
//       endPage = 10;
//     } else if (currentPage + 4 >= totalPages) {
//       startPage = totalPages - 9;
//       endPage = totalPages;
//     } else {
//       startPage = currentPage - 5;
//       endPage = currentPage + 4;
//     }
//   }

//   // calculate start and end item indexes
//   const startIndex = (currentPage - 1) * pageSize;
//   const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

//   // create an array of pages to ng-repeat in the pager control
//   const pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

//   // return object with all pager properties required by the view
//   return {
//     totalItems,
//     currentPage,
//     pageSize,
//     totalPages,
//     startPage,
//     endPage,
//     startIndex,
//     endIndex,
//     pages,
//   };
// };

export const modifyOrganisationsList = (organisationOdata) => {
  const { value } = organisationOdata;
  const organisationItems = [];
  value.forEach((organisation) => {
    const { name, id } = organisation;
    organisationItems.push({
      label: name,
      value: id,
    });
  });
  return organisationItems;
};

export const modifyUsersList = (users) => {
  const userItems = [];
  users.forEach((user) => {
    const { displayName, id, email } = user;
    userItems.push({
      label: `${displayName} | ${email}`,
      value: id,
    });
  });
  return userItems;
};

export const modifyDevicesList = (devices) => {
  const deviceItems = [];
  devices.forEach((device) => {
    const { name, id, deviceKey, slaveCountToConnect } = device;
    deviceItems.push({
      label: `${name} | ${deviceKey}`,
      value: id,
      slaveCountToConnect: slaveCountToConnect
    });
  });
  return deviceItems;
};

export const modifyAssignedDevicesList = (devices, isEndUser) => {
  const deviceItems = [];
  devices.forEach((device) => {
    const { name, deviceKey, friendlyName, roomName } = device;
    deviceItems.push({
      label: isEndUser ? `${deviceKey} | ${friendlyName} | ${roomName}` : `${name} | ${deviceKey}`,
      value: deviceKey,
    });
  });
  return deviceItems;
};
export const modifyRequestReasonList = (reasons) => {
  const reasonItems = [];
  reasons.forEach((reasonData) => {
    const { reason, id } = reasonData;
    reasonItems.push({
      label: reason,
      value: id,
    });
  });
  return reasonItems;
};

export const modifyGroupsList = (groups) => {
  const groupItems = [];
  groupItems.unshift({
    value: null,
    label: "None",
  });
  groups.forEach((group) => {
    const { groupName, id } = group;
    groupItems.push({
      label: groupName,
      value: id,
    });
  });
  return groupItems;
};
export const modifyCategoryList = (category) => {
  const groupItems = [];
  category.forEach((category) => {
    const { categoryName } = category;
    groupItems.push({
      label: categoryName,
      value: categoryName,
    });
  });
  return groupItems;
};

export const modifyProductList = (products) => {
  const productItems = [];
  products.forEach((product) => {
    const { productName } = product;
    productItems.push({
      label: productName,
      value: productName,
    });
  });
  return productItems;
};

export const modifyReturnReasonList = (products) => {
  const productItems = [];
  products.forEach((product) => {
    const { productName } = product;
    productItems.push({
      label: productName,
      value: productName,
    });
  });
  return productItems;
};

export const modifyZoneList = (zones) => {
  const zoneItems = [];
  zones.forEach((zone) => {
    const { zoneName } = zone;
    zoneItems.push({
      label: zoneName,
      value: zoneName,
    });
  });
  return zoneItems;
};

export const modifyStateList = (states) => {
  const stateItems = [];
  states.forEach((state) => {
    const { stateName } = state;
    stateItems.push({
      label: stateName,
      value: stateName,
    });
  });
  return stateItems;
};
